module.exports = __webpack_public_path__ + "img/banner_7.773af3f1.jpg";